export var TRANSITION_STATES;
(function (TRANSITION_STATES) {
    TRANSITION_STATES["ENTERED"] = "entered";
    TRANSITION_STATES["EXITED"] = "exited";
})(TRANSITION_STATES || (TRANSITION_STATES = {}));
export const DEFAULT_DURATION = 300;
//# sourceMappingURL=types.js.map